<script setup lang="ts">
import {authStore} from "~/stores/authStore";
import {loadingStore} from "~/stores/loadingStore";
import {useRouter} from "vue-router";
import type {Numeric} from "type-fest/source/numeric";
import PaymentSidebar from "~/components/payments/paymentSidebar.vue";

const {$api, $toast} = useNuxtApp()
const router = useRouter()
const auth = authStore()
const {headers} = storeToRefs(auth)
const invoice = ref('')
const invoice_id = ref('')
const loading = loadingStore()
const {setLoading} = loading
const methods = await $api.get('user/methods', headers.value)
const {user} = auth
definePageMeta({
  middleware: 'auth'
})
onMounted(() => {
  $('.customer-photo').change(function () {
    $(this).parents('.sendForm').children('.row').children('.show-photo').children('.photo-down').attr('src', URL.createObjectURL(event.target.files[0]));
    $(this).parents('.sendForm').children('.row').children('.show-photo').show()
  })


  $('.report').click(function () {
    var thiss = $(this)
    if ($(this).children('i').attr('class') === 'fas fa-sort-down v-1') {
      $('.sendForm').hide('slow')
      $('.cards-inform').children('button').children('i').attr('class', 'fas fa-sort-down v-1')
      $(this).children('i').attr('class', 'fas fa-sort-up')
      $(this).parents('.getForm').children('.sendForm').show('slow')
    } else {
      $(this).children('i').attr('class', 'fas fa-sort-down v-1')
      $(this).parents('.getForm').children('.sendForm').hide('slow')
    }
    thiss.attr('disabled', 'true')
    setTimeout(function () {
      thiss.removeAttr('disabled')
    }, 1000)
  })
  $('.show-photo span').click(function () {
    $(this).parents('.show-photo').hide()
    $(this).parents('.sendForm').children('.row').children('.show-photo').children('.photo-down').attr('src', '')
  })

})
useHead({
  title: 'Ödəniş növləri'
})
const sendPayment = () => {
  setLoading(true)
  const formData = new FormData();
  formData.append('invoice', invoice.value)
  $api.post('user/payment/invoice', formData, headers.value).then(res => {
    router.push('/user/dashboard/payments').then(() => {
      $toast.success('Çek uğurla göndərildi.')
    })
  }).catch((error) => {
    $toast.error(error)
  }).finally(() => {
    setLoading(false)
    $('.photo-down').attr('src', '')
    $('.show-photo').hide()
    invoice.value = ''
  })
}
const addPhoto = (event:any, id:Numeric) => {
  invoice.value = event.target.files[0]
  invoice_id.value = id
}
</script>

<template>
  <main>
    <!-- Payment notification -->
    <div v-if="user.level === 'normal'" class="container">
      <div class="payment-notification">
        <div class="notification-content">
          <i class="fas fa-info-circle"></i>
          <p>Ödənişlər hər gün <strong>11:00 – 00:00</strong> arası manuel olaraq <strong>5–15 dəqiqə</strong> ərzində artırılır. Dərhal artırmaq üçün <nuxt-link to="/payments/online">onlayn balans artırma</nuxt-link> bölməsindən istifadə edin.</p>
        </div>
      </div>
    </div>

    <!-- Mobile and PC title -->
    <div class="container back-orange set-size">
      <div class="row">
        <div class="col-md-12">
          <div class="main-title">
            <h5> Balans artır </h5>
            <div class="single-sub-menu">
              <i class="fal fa-angle-down"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- PC and Mobile sub title -->
    <div class="container">
      <div class="row reset-margin">

        <!-- PC sub menus -->
        <div class="col-lg-3">
          <payment-sidebar />
        </div>

        <!-- Mobile and PC menu and payments -->
        <div class="col-lg-9">
          <div class="right-part">
            <div class="row hide-show">

              <!-- PC and Mobile title -->
              <div class="col-md-12">
                <h5 class="simple-title">Bank Hesabları</h5>
              </div>

              <section v-for="(method, index) in methods.data" class="col-md-12">
                <div class="row getForm">
                  <div class="col-md-4">
                    <div class="cards-inform">
                      <img :src="method.image" :alt="method.name">
                    </div>
                  </div>
                  <div class="col-md-4 col-6">
                    <div class="cards-inform">
                      <h6>Bankın adı</h6>
                      <p>{{ method.name }}</p>
                      <div v-for="(prop, key) in method.props">
                        <h6>{{ key }}</h6>
                        <p>{{ prop }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <hr class="measure">
                  </div>
                  <form @submit.prevent="sendPayment" class="col-md-12 sendForm" method="post"
                        enctype="multipart/form-data">
                    <div class="row">
                      <div class="col-6">
                        <div class="receipt-photo">
                          <label :for="'receipt-'+method.id"> Qəbzi seç </label>
                          <input @change="addPhoto($event, method.id)" name="image" accept="image/*" class="customer-photo" hidden :id="'receipt-'+method.id"
                                 type="file">
                        </div>
                      </div>
                      <div class="col-6 findSet">
                        <div class="send">
                          <button v-if="invoice && invoice_id === method.id" type="submit"> Yükləyin</button>
                        </div>
                      </div>
                      <div class="col-md-12 show-photo">
                        <img class="photo-down" src="" alt="">
                        <span><i class="fas fa-times-circle"></i></span>
                      </div>
                      <div class="col-md-12">
                        <div class="measure">
                          <hr>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </section>


            </div>
          </div>
        </div>

      </div>
    </div>

  </main>
</template>

<style scoped>
 .sendForm {
   display: block !important;
 }

 .payment-notification {
   background-color: #fff8e1;
   border-left: 4px solid #ffc107;
   border-radius: 4px;
   padding: 15px;
   margin: 15px 0;
   box-shadow: 0 2px 5px rgba(0,0,0,0.1);
 }

 .notification-content {
   display: flex;
   align-items: flex-start;
 }

 .notification-content i {
   color: #ff9800;
   font-size: 20px;
   margin-right: 10px;
   margin-top: 2px;
 }

 .notification-content p {
   margin: 0;
   color: #5d4037;
   font-size: 14px;
   line-height: 1.5;
 }

 .notification-content strong {
   color: #e65100;
 }

 .notification-content a {
   color: #1976d2;
   text-decoration: underline;
   font-weight: bold;
 }

 .notification-content a:hover {
   color: #0d47a1;
 }
</style>